export default [
  {
    path: '/apps/workflow/list',
    name: 'apps-workflow-list',
    component: () => import('@/views/app/worflow/worflow/list/Index.vue'),
    meta: {
      pageTitle: 'WorkFlow',
    },
  },
];
